import { widgetSetupSelector } from "../widgetSetupSelector";
import { RootState } from "@/store/store";

export const widgetSetupWidgetSyncedWithDashboardSelector = (
  state: RootState,
) => {
  const setup = widgetSetupSelector(state);

  if (!setup) {
    return false;
  }

  return !!("inheritDates" in setup && setup?.inheritDates);
};
